import {StorageService} from "./storage.service";

export class StorageDto<T> {

  private readonly value: T;
  private readonly expire: number;

  constructor(value: T, expire: number) {
    this.value = value;
    this.expire = expire;
  }

  public notExpired(): boolean {
    return !this.isExpired();
  }

  public isExpired(): boolean {
    if (this.expire === StorageService.EXPIRE_UNLIMITED) {
      return false;
    }
    return Date.now() >= this.expire;
  }

  public getValue(): T {
    return this.value;
  }
}
